// extracted by mini-css-extract-plugin
module.exports = {"shop-section":"shop-by-category-loader_shop-section__ZFtfo","loader-container":"shop-by-category-loader_loader-container__0mUSc"};